import { types } from '../../../types/types';

export const pesquisaPaisesReducer = (state = {}, action = {}) => {    
    let result = {};
    switch (action.type) {
        case types.ENDERECO.PESQUISA_PAIS:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const tipologradourosReducers = (state = {}, action = {}) => {
    let result = {};

    switch (action.type) {
        case types.ENDERECO.PESQUISA_TIPOLOGRAOURO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const cepReducers = (state = {}, action = {}) => {
    let result = {};

    switch (action.type) {
        case types.ENDERECO.PESQUISA_CEP:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const estadosReducers = (state = {}, action = {}) => {
    let result = {};

    switch (action.type) {
        case types.ENDERECO.PESQUISA_ESTADOS:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}